import { makeStyles } from '@material-ui/core';
import { ArrayUtils } from '@timeflies/common';
import clsx from 'clsx';
import React from 'react';
var useStyles = makeStyles(function (_a) {
    var palette = _a.palette;
    return ({
        root: function (_a) {
            var height = _a.height;
            return ({
                display: 'flex',
                flexWrap: 'nowrap',
                height: height,
                flexGrow: 1
            });
        },
        tock: function (_a) {
            var tockMaxWidth = _a.tockMaxWidth, tockSpacing = _a.tockSpacing;
            return ({
                height: '100%',
                width: "calc(25% - " + tockSpacing * (4 / 5) + "px)",
                maxWidth: tockMaxWidth,
                backgroundColor: palette.timeItems.tock
            });
        },
        tockSpace: function (_a) {
            var tockSpacing = _a.tockSpacing;
            return ({
                marginLeft: tockSpacing
            });
        },
        tick: function (_a) {
            var tickMaxWidth = _a.tickMaxWidth;
            return ({
                flexGrow: 1,
                height: '100%',
                maxWidth: tickMaxWidth,
                minWidth: 1,
                backgroundColor: palette.timeItems.tick
            });
        },
        tickSpace: function (_a) {
            var tickSpacing = _a.tickSpacing;
            return ({
                marginLeft: tickSpacing
            });
        },
    });
});
export var TimeGaugeRaw = function (_a) {
    var duration = _a.duration, height = _a.height, tockMaxWidth = _a.tockMaxWidth, tockSpacing = _a.tockSpacing, tickMaxWidth = _a.tickMaxWidth, tickSpacing = _a.tickSpacing;
    var classes = useStyles({ height: height, tockMaxWidth: tockMaxWidth, tockSpacing: tockSpacing, tickMaxWidth: tickMaxWidth, tickSpacing: tickSpacing });
    if (duration > 1000000) {
        throw new Error('Duration too high, probably bad value: ' + duration);
    }
    var seconds = Math.ceil(duration / 1000);
    var nbrTocks = Math.floor(seconds / 5);
    var nbrTicks = seconds % 5;
    return React.createElement("div", { className: classes.root },
        ArrayUtils.range(nbrTocks)
            .map(function (i) {
            var _a;
            return (React.createElement("div", { key: i, className: clsx(classes.tock, (_a = {},
                    _a[classes.tockSpace] = i !== 0,
                    _a)) }));
        }),
        ArrayUtils.range(nbrTicks)
            .map(function (i) {
            var _a;
            return (React.createElement("div", { key: i, className: clsx(classes.tick, (_a = {},
                    _a[classes.tockSpace] = i === 0 && nbrTocks > 0,
                    _a[classes.tickSpace] = i !== 0,
                    _a)) }));
        }));
};
